export default "__VITE_ASSET__D0YAK7Kt__"